<template>
  <div v-if="this.isLoading">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
  <div v-else>
    <app-gridview v-bind:parentData="{
      pageTitle: this.pageTitle,
      tabHeaders: this.dataHeader,
      tabItems: this.dataItems,
      search: this.search,
      isDelete: true,
    }" 
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)" 
      v-on:NewPressed="newRecordHandler">
    </app-gridview>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          messageConfirm: this.messageConfirm,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteItemHandlerAction"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>
<script>
//import moment from 'moment';
import GridView from "../../../components/common/GridView";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-gridview": GridView,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      pageTitle: this.$t('pmrewardrecord.title'),
      dataHeader: [
        { text: '', value: "action", sortable: false, width: "100px" },
        { text: this.$t('pmrewardrecord.simulationcode'), value: "simulationcode", sortable: false, width: "auto" },
        { text: this.$t('pmrewardrecord.simulationdesc'), value: "simulationdesc", sortable: false, width: "auto" },
        { text: this.$t('pmassementrecord.pmassessmentcode'), value: "pmassessmentrecordcode", sortable: false, width: "auto" },
        { text: this.$t('columns.status'), value: "rewardstatuscode", sortable: false, width: "auto" },
        { text: this.$t('pmrewardrecord.currencycode'), value: "currencycode", sortable: false, width: "auto" },
      ],
      dataItems: [],
      isLoading: true,
      errMsg: '',
      isConfirm: false,
      messageConfirm:'',
      selectedItem: null,
      search: this.$route.params.search,
    };
  },

  methods: {

    async getRewardRecordHandler() {
      try {
        const res = await this.$store.dispatch('get', { url: "/pmrewardrecord/all" });
        this.dataItems = res.data.rec;

      } catch (err) {
        console.log("error on reward record", err);
        this.errMsg = err;
      }
    },

    newRecordHandler() {
      this.$router.push({ name: "pmrewardrecordnew" });
    },
    
    deleteItemHandler(item) {
      this.messageConfirm = this.$t('pmrewardrecord.confirmDelete', { code: item.simulationcode });
      this.selectedItem = item;
      this.isConfirm=true;
    },
    deleteItemHandlerAction() {
      const vm = this;

      if (!this.selectedItem) {
          console.error(" No item selected for deletion!");
          return;
      }
      const deleteUrl = "/pmrewardrecord/" + vm.selectedItem.id;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url: deleteUrl})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            window.location.reload();
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
      vm.selectedItem = null; // 🔹 Clear after deletion
      this.isConfirm = false;  // 🔹 Close confirmation dialog
    },

    editItemHandler(item) {
      this.$router.push({ name: "pmrewardrecordedit", params: { id: item.id,search: item.search } });
    },
    
  },
  
  async mounted() {
    await this.getRewardRecordHandler();
    this.isLoading = false;//then can start to display page 
  },
};
</script>